import { FC } from "react";

interface IconSVGProps {
    width?: number;
    height?: number;
}

const IconSVG: FC<IconSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 7.00006C0.5 3.27214 3.52208 0.250061 7.25 0.250061H15.25C17.8734 0.250061 20 2.37671 20 5.00006C20 7.62341 17.8734 9.75006 15.25 9.75006H7.10714C5.58836 9.75006 4.35714 8.51884 4.35714 7.00006C4.35714 5.48128 5.58836 4.25006 7.10714 4.25006H14.9643C15.3785 4.25006 15.7143 4.58585 15.7143 5.00006C15.7143 5.41427 15.3785 5.75006 14.9643 5.75006H7.10714C6.41679 5.75006 5.85714 6.3097 5.85714 7.00006C5.85714 7.69042 6.41679 8.25006 7.10714 8.25006H15.25C17.0449 8.25006 18.5 6.79499 18.5 5.00006C18.5 3.20514 17.0449 1.75006 15.25 1.75006H7.25C4.3505 1.75006 2 4.10057 2 7.00006C2 9.89956 4.35051 12.2501 7.25 12.2501H14.9643C15.3785 12.2501 15.7143 12.5858 15.7143 13.0001C15.7143 13.4143 15.3785 13.7501 14.9643 13.7501H7.25C3.52208 13.7501 0.5 10.728 0.5 7.00006Z" fill="#A9AEF6"/>
      </svg>
    );
};

export default IconSVG;
